import getDomain from './get-domain';

/* returns true if its test environment [local/vbox]
*/
const isTestEnvironment = () => {
  const domainNames = getDomain().split('.');
  return !domainNames[0].includes('secure');
};

export default isTestEnvironment;
